

import * as actionTypes from './actionTypes';
import * as actions from './index';

export const updateAiObjects = (data) => {
    return {
        type: actionTypes.AI_UPDATE_AIOBJECTS,
        payload: data
    }
}

export const setAiLoading = (data) => {
    return {
        type: actionTypes.AI_SET_LOADING,
        payload: data
    }
}

export const detectAiObjects = () => {
    return async (dispatch, getState) => {
        const { aiDetectObj } = getState().ai.aiObjects;
        // const res = await window.flow.detectAiObjects();
        //console.log("LOGS: LAMTEST detectAiObjects", res);
    }
}

export const whisperAiObjects = ({ clipId }) => {
    return async (dispatch) => {
        console.log("LOGS: whisperAiObjects clipId", clipId);
        const res = await window.flow.processCreate('batch', 'whisper',
            { clipid: clipId, parameters: { batch: 7 } });
        console.log("LOGS: whisperAiObjects", res);
    }
}

export const tesseractAiObjects = ({ clipId }) => {
    return async (dispatch, getState) => {
        const { aiTesseract } = getState().ai.aiObjects;
        dispatch(setAiLoading(true));
        try {
            let clipRes = await window.flow.tesseractProcessClip(clipId);
            let ocrRes = clipRes.getMetadata().get('ocr');
            if (ocrRes) {
                console.log("LOGS ocrRes=OK");
                dispatch(updateAiObjects({
                    aiTesseract: { ...aiTesseract, ocr: ocrRes, showOverlay: true }
                }));
                dispatch(setAiLoading(false));
            } else {
                console.log("LOGS ocrRes=Null");
                dispatch(updateAiObjects({ aiTesseract: { showOverlay: false } }));
                dispatch(setAiLoading(false));
            }
        } catch (e) {
            dispatch(updateAiObjects({ aiTesseract: { showOverlay: false } }));
            console.log("LOGS: tesseractAiObjects e", e);
            dispatch(setAiLoading(false));
        }
    }
}
